import React, { useEffect, useState } from "react";
import Footer from "../Footer/Footer";
import Header from "./../Header/Header";
import "./SingleProduct.css";
import Rating from "@mui/material/Rating";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import { faHeart } from "@fortawesome/free-regular-svg-icons";
import { Link, useNavigate, useParams } from "react-router-dom";
import axios from "axios";

const SingleProduct = () => {
  const { productId } = useParams();
  const [products, setProducts] = useState([]);
  const navigate=useNavigate();

  const { artist, subject, style, medium, specification } = products;
  const myArray = specification?.split(",");

  const addToCartHandler=()=>{
    navigate(`/cart/${productId}`)
  }


  useEffect(() => {
    axios.get(`https://skabelse.herokuapp.com/painting/${productId}`).then((res) => {
      setProducts(res.data);
    });
  }, [productId]);

  return (
    <div className="singleProduct bg-dark">
      <Header />
      <div className="description my-5">
        <div className="container">
          <div className="art_description mb-5">
            <div className="row">
              <div className="col-lg-1">
                <div className="catalog_image mb-3">
                  <img className="" src={products.main_image} alt="" />
                </div>
                <div className="catalog_image mb-3">
                  {products.wall_image ? (
                    <img className="" src={products.wall_image} alt="" />
                  ) : (
                    <img
                      className=""
                      src={require("../../Asset/singleProduct/catalougue1.png")}
                      alt=""
                    />
                  )}
                </div>
              </div>
              <div className="col-lg-6">
                <div className="catalougue_mainImage">
                  <img className="" src={products.main_image} alt="" />
                </div>
              </div>
              <div className="col-lg-5 ">
                <div className="bg_Dark rounded-3 mb-3">
                  <div className="row p-3">
                    <div className="col-lg-8 artist_profile_small">
                      <div className="d-flex align-items-center">
                        <div className="profile_image_zoomOut me-3">
                          {products.artist?.artist_image ? (
                            <img
                              className=""
                              src={products.artist?.artist_image}
                              alt=""
                            />
                          ) : (
                            <img
                              className=""
                              src={require("../../Asset/artist/artist_profile_img.png")}
                              alt=""
                            />
                          )}
                        </div>
                        <div className="profile_text">
                          <h5 className="text-white m-0">
                            {artist?.artist_name}
                          </h5>
                          <p className="fs16  cl-lightGrey m-0">
                            {artist?.artist_country}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-4 d-flex justify-content-end align-items-center">
                      <Link class="btn cl-pm"  to={`/sartist/${artist?.id}`} role="button">
                        View Collections
                      </Link>
                    </div>
                  </div>
                </div>

                <div className="content">
                  <p className="cl-pm semibold fs18">Specifications</p>
                  <ul class="text-white">
                    {myArray?.map((a) => (
                      <li>{a}</li>
                    ))}
                  </ul>
                  <p className="text-white semibold fs30">
                    $
                    <span className="mx-3 cl-pm semibold">
                      {products.price}
                    </span>
                  </p>

                  <div className="content_link_btn d-flex mb-4">
                    <button
                      type="button"
                      className="me-3 allbutton cl_y px-3 py-2 border-1"
                      onClick={addToCartHandler}
                    >
                      Add to Cart
                    </button>
                    <a class="btn white" href="/" role="button">
                      Make an Offer
                    </a>
                  </div>
                  <p className="text-white d-flex align-items-center mb-4">
                    <Rating
                      className="me-3"
                      name="read-only"
                      value="2"
                      readOnly
                    />
                    (<span>298</span>)
                  </p>
                  <div className="views_like d-flex">
                    <div class="views d-flex  text-white me-4">
                      <div class="vl_icon d-flex align-items-center justify-content-center">
                        <FontAwesomeIcon className="cl-pm" icon={faEye} />
                      </div>
                      <div class="vl_text d-flex align-items-center">
                        <div className="d-flex flex-column">
                          <p className="m-0">2033</p>
                          <p className="m-0">Views</p>
                        </div>
                      </div>
                    </div>

                    <div class="views d-flex  text-white me-4">
                      <div class="vl_icon d-flex align-items-center justify-content-center">
                        <FontAwesomeIcon className="cl-pm" icon={faHeart} />
                      </div>
                      <div class="vl_text d-flex align-items-center">
                        <div className="d-flex flex-column">
                          <p className="m-0">{products.like}</p>
                          <p className="m-0">Likes</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* description_tab */}
          <div className="description_tab mb-5">
            <nav>
              <div className="nav nav-tabs" id="nav-tab" role="tablist">
                <a
                  className="nav-link active me-3 mb-1"
                  id="nav-home-tab"
                  data-bs-toggle="tab"
                  href="#nav-home"
                  role="tab"
                  aria-controls="nav-home"
                  aria-selected="true"
                >
                  About The Artwork
                </a>
                <a
                  className="nav-link me-3 mb-1"
                  id="nav-details-tab"
                  data-bs-toggle="tab"
                  href="#nav-details"
                  role="tab"
                  aria-controls="nav-details"
                  aria-selected="false"
                >
                  Details & Dimensions
                </a>
                <a
                  className="nav-link me-3 mb-1"
                  id="nav-return-tab"
                  data-bs-toggle="tab"
                  href="#nav-return"
                  role="tab"
                  aria-controls="nav-return"
                  aria-selected="false"
                >
                  Shipping & Returns
                </a>
              </div>
            </nav>
            <div
              className="bg_Dark tab-content text-white mt-5"
              id="nav-tabContent"
            >
              <div
                className="tab-pane  fade show active p-5"
                id="nav-home"
                role="tabpanel"
                aria-labelledby="nav-home-tab"
              >
                <p>{products.introduction}</p>
                <table
                  className="table table-borderless"
                  style={{ color: "white" }}
                >
                  <tbody>
                    <tr className="">
                      <th className="w15 semibold" scope="row">
                        Original Created:
                      </th>
                      <td className="">
                        <span className="">{products.created_year}</span>
                      </td>
                    </tr>
                    <tr className="">
                      <th className="w15 semibold" scope="row">
                        Subjects:
                      </th>
                      <td>
                        {subject?.map((s) => (
                          <span>{s.name}, &nbsp;</span>
                        ))}
                      </td>
                    </tr>
                    {/*  */}
                    <tr className="">
                      <th className="w15 semibold" scope="row">
                        Materials:
                      </th>
                      <td className="">{products.material}</td>
                    </tr>
                    <tr className="">
                      <th className="w15 semibold" scope="row">
                        Styles:
                      </th>
                      <td>
                        {style?.map((s) => (
                          <span>{s.name}, &nbsp;</span>
                        ))}
                      </td>
                    </tr>
                    <tr className="">
                      <th className="w15 semibold" scope="row">
                        Mediums:
                      </th>
                      <td>
                        {medium?.map((s) => (
                          <span>{s.name},&nbsp;</span>
                        ))}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div
                className="tab-pane fade show p-5"
                id="nav-details"
                role="tabpanel"
                aria-labelledby="nav-profile-tab"
              >
                <table
                  className="table table-borderless"
                  style={{ color: "white" }}
                >
                  <tbody>
                    <tr className="">
                      <th className="w15 semibold" scope="row">
                        Description:
                      </th>
                      <td className="">
                        <span className="">{products.description}</span>
                      </td>
                    </tr>

                    {/*  */}
                    <tr className="">
                      <th className="w15 semibold" scope="row">
                        Orientation:
                      </th>
                      <td className="">{products.orientation}</td>
                    </tr>
                    <tr className="">
                      <th className="w15 semibold" scope="row">
                        Size:
                      </th>
                      <td>{products.size}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div
                className="tab-pane fade show p-5"
                id="nav-return"
                role="tabpanel"
                aria-labelledby="nav-return-tab"
              >
                <p>{products.shipping}</p>
              </div>
            </div>
          </div>
          {/* artist profile */}
          <div className="artist_profile">
            {/* content  */}
            <div className="row mb-3">
              <div className="col-lg-8">
                <div className="d-flex align-items-center">
                  <div className="profile_image_zoom me-4 mb-3">
                    {artist?.artist_image ? (
                      <img className="" src={artist?.artist_image} alt="" />
                    ) : (
                      <img
                        className=""
                        src={require("../../Asset/singleProduct/dummy_profile.png")}
                        alt=""
                      />
                    )}
                  </div>
                  <div className="profile_text">
                    <h4 className="text-white"> {artist?.artist_name}</h4>
                    <p className="fs16  cl-lightGrey my-2">
                      {" "}
                      {artist?.artist_country}
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 d-flex justify-content-end align-items-center">
                <Link
                  type="button"
                  className="allbutton cl_y px-3 py-2 border-1"
                 to={`/sartist/${artist?.id}`}
                >
                  View Profile
                </Link>
              </div>
            </div>
            <div className="">
              <p className="fs16  text-white my-2">{artist?.artistry}</p>
            </div>
          </div>
        </div>
      </div>
      {/* similar artwork/ rising star */}
      <div className="risingStar">
        <div className="container">
          <div className="header d-flex justify-content-between align-items-center mb-4">
            <h1 className="text-white">Visually Similar Artworks</h1>
          </div>
          <div className="d-flex flex-wrap align-items-center justify-content-center">
            <div className="w20 mb-3 risingStar_content">
              <div className="risingStar_contentImg mb-3">
                <img
                  className=""
                  src={require("../../Asset/index/risingStr1.png")}
                  alt=""
                />
              </div>
              <div>
                <h6 className="semibold text-white m-0">Borg de Nobel</h6>
                <p className="fs16  cl-lightGrey my-2">Netherlands</p>
                <p className="fs20 cl-pm m-0">
                  {" "}
                  $ <span>2,300</span>
                </p>
              </div>
            </div>
            <div className="w20 mb-3 risingStar_content">
              <div className="risingStar_contentImg mb-3">
                <img src={require("../../Asset/index/risingStr2.png")} alt="" />
              </div>
              <div>
                <h6 className="semibold text-white m-0">Borg de Nobel</h6>
                <p className="fs16  cl-lightGrey my-2">Netherlands</p>
                <p className="fs20 cl-pm m-0">
                  {" "}
                  $ <span>2,300</span>
                </p>
              </div>
            </div>
            <div className="w20 mb-3 risingStar_content">
              <div className="risingStar_contentImg mb-3">
                <img src={require("../../Asset/index/risingStr3.png")} alt="" />
              </div>
              <div>
                <h6 className="semibold text-white m-0">Borg de Nobel</h6>
                <p className="fs16  cl-lightGrey my-2">Netherlands</p>
                <p className="fs20 cl-pm m-0">
                  {" "}
                  $ <span>2,300</span>
                </p>
              </div>
            </div>
            <div className="w20 mb-3 risingStar_content">
              <div className="risingStar_contentImg mb-3">
                <img src={require("../../Asset/index/risingStr4.png")} alt="" />
              </div>
              <div>
                <h6 className="semibold text-white m-0">Borg de Nobel</h6>
                <p className="fs16  cl-lightGrey my-2">Netherlands</p>
                <p className="fs20 cl-pm m-0">
                  {" "}
                  $ <span>2,300</span>
                </p>
              </div>
            </div>
            <div className="w20 mb-3 risingStar_content">
              <div className="risingStar_contentImg mb-3">
                <img src={require("../../Asset/index/risingStr5.png")} alt="" />
              </div>
              <div>
                <h6 className="semibold text-white m-0">Borg de Nobel</h6>
                <p className="fs16  cl-lightGrey my-2">Netherlands</p>
                <p className="fs20 cl-pm m-0">
                  {" "}
                  $ <span>2,300</span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default SingleProduct;
 